import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { File } from '../employee/models/File';
import { EmployeeAction } from '../employee/services/employee-action.service';
import { InternalDocument } from '../internal-document/state/internal-document.model';
import { Comment } from '../shared/models/Comment';
import { TermWatch } from '../term-watch/state/term-watch.model';

export interface DashboardStats {
    attendance_to_approve: number;
    attendance_to_approve_mine: number;
    entity_requests: number;
    entity_requests_mine: number;
    unsigned_documents: number;
    active_onboardings: number | false;
    active_growths: number;
    unprocessed_forms: number;
    cooperated_recruitments: number;
}

export interface DashboardInfo {
    last_pinned_comment: Comment;
    unsigned_files: File[];
    unreaded_documents: InternalDocument[];
    term_watches: TermWatch[];
    pending_actions: EmployeeAction[];
}

@Injectable({
    providedIn: 'root'
})

export class DashboardService {

    public constructor(
        private _http: HttpClient,
    ) { }

    public getDashboardStats(scope = ''): Observable<DashboardStats> {
        return this._http.get<DashboardStats>(`/api/dashboard/stats`, {
            params: {
                scope
            }
        });
    }

    public getDashboardInfo(userID: number): Observable<DashboardInfo> {
        return this._http.get<DashboardInfo>(`/api/dashboard/${userID}/information`);
    }
}
